// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"290":"1fd6e8df","449":"0b3f910a"}[chunkId] + ".chunk.css";
};